import type { AnnotationFrameDraft } from "./types";

type OrderableFrame = Pick<AnnotationFrameDraft, "sequenceId" | "timestampSeconds">;

export function orderFrameIdsBySequenceAndTime(
  frameIds: readonly string[],
  frames: Readonly<Record<string, OrderableFrame | undefined>>,
  sequenceIds: readonly string[],
): string[] {
  const sequenceOrder = new Map(sequenceIds.map((sequenceId, index) => [sequenceId, index]));
  const insertionOrder = new Map(frameIds.map((frameId, index) => [frameId, index]));

  return [...frameIds].sort((leftId, rightId) => {
    const left = frames[leftId];
    const right = frames[rightId];
    const fallback = (insertionOrder.get(leftId) ?? 0) - (insertionOrder.get(rightId) ?? 0);

    if (!left || !right) {
      if (!left && !right) return fallback;
      return left ? -1 : 1;
    }

    const sequenceDifference =
      (sequenceOrder.get(left.sequenceId) ?? Number.MAX_SAFE_INTEGER) -
      (sequenceOrder.get(right.sequenceId) ?? Number.MAX_SAFE_INTEGER);
    if (sequenceDifference !== 0) return sequenceDifference;

    const leftTimestamp = Number.isFinite(left.timestampSeconds)
      ? left.timestampSeconds
      : Number.POSITIVE_INFINITY;
    const rightTimestamp = Number.isFinite(right.timestampSeconds)
      ? right.timestampSeconds
      : Number.POSITIVE_INFINITY;
    const timestampDifference = leftTimestamp - rightTimestamp;
    return timestampDifference !== 0 ? timestampDifference : fallback;
  });
}
